import { TransportOrderIdView } from '../../../../models';

export class ShipmentTransportOrderOuterPackagesListLoad {
  public static readonly type = '[ShipmentTransportOrderOuterPackagesList] Load';
  constructor(public payload: TransportOrderIdView) {}
}

export class ShipmentTransportOrderOuterPackagesListInitialState {
  public static readonly type = '[ShipmentTransportOrderOuterPackagesList] Set Initial State';
}
